var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConectia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "neonGlowMark",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyberMetalMark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080C0E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 15,
    fill: "#111418"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 90,
    height: 90,
    rx: 12,
    fill: "none",
    stroke: "#4DD0E1",
    strokeWidth: 2.2,
    filter: "url(#neonGlowMark)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#neonGlowMark)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 28,
    height: 20,
    rx: 1,
    fill: "url(#cyberMetalMark)",
    stroke: "#4DD0E1",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54 26 h 27 a 1 1 0 0 1 1 1 v 46 a 1 1 0 0 1 -1 1 h -13 a 1 1 0 0 1 -1 -1 v -26 h -13 a 1 1 0 0 1 -1 -1 v -19 a 1 1 0 0 1 1 -1 z",
    fill: "url(#cyberMetalMark)",
    stroke: "#4DD0E1",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18 54 h 13 a 1 1 0 0 1 1 1 v 5 h 13 a 1 1 0 0 1 1 1 v 12 a 1 1 0 0 1 -1 1 h -27 a 1 1 0 0 1 -1 -1 v -18 a 1 1 0 0 1 1 -1 z",
    fill: "url(#cyberMetalMark)",
    stroke: "#4DD0E1",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectia);
export default __webpack_public_path__ + "static/media/conectia.99bfa57cfee0418fb322a3a71dbe6c8f.svg";
export { ForwardRef as ReactComponent };